import { COMPANY } from "../data/company";
import { LegalLayout } from "../components/LegalLayout";

export default function Garantie() {
  return (
    <LegalLayout
      title="Politica de garanție"
      subtitle="Toate produsele beneficiază de garanția legală a conformității conform Legii 449/2003."
      lastUpdated="Februarie 2026"
    >
      <h2 className="font-heading text-xl font-bold text-slate-900">1. Garanția legală</h2>
      <p>
        Toate produsele comercializate beneficiază de garanția legală de
        conformitate conform <strong>Legii 449/2003</strong> privind vânzarea
        produselor și garanțiile asociate acestora.
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900">2. Termenul de garanție</h2>
      <p>
        Termenul de valabilitate al produselor este înscris pe ambalaj. Pe toată
        durata de valabilitate, garantăm că produsele:
      </p>
      <ul className="list-disc pl-6 space-y-1">
        <li>Corespund descrierii făcute de vânzător</li>
        <li>Sunt adecvate scopului pentru care sunt utilizate de obicei</li>
        <li>Prezintă calitatea și performanțele descrise pe ambalaj</li>
      </ul>

      <h2 className="font-heading text-xl font-bold text-slate-900">3. Ce acoperă garanția</h2>
      <p>
        Garanția acoperă viciile ascunse, defectele de fabricație și
        neconformitățile produsului față de descrierea de pe site sau de pe
        ambalaj.
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900">4. Ce NU acoperă garanția</h2>
      <ul className="list-disc pl-6 space-y-1">
        <li>Defecte cauzate de utilizarea necorespunzătoare</li>
        <li>Produsele expirate sau deteriorate prin neglijența clientului</li>
        <li>
          Utilizarea produsului contrar instrucțiunilor de pe ambalaj
        </li>
      </ul>

      <h2 className="font-heading text-xl font-bold text-slate-900">5. Cum poți invoca garanția</h2>
      <ol className="list-decimal pl-6 space-y-2">
        <li>
          Contactează-ne la {COMPANY.phone} sau{" "}
          <a href={`mailto:${COMPANY.email}`} className="text-cyan-600 underline">
            {COMPANY.email}
          </a>{" "}
          și descrie problema, atașând foto/video dacă este posibil.
        </li>
        <li>
          Vom analiza solicitarea în maximum 15 zile lucrătoare de la primire.
        </li>
        <li>
          În funcție de situație, vom propune: înlocuirea produsului, rambursarea
          contravalorii sau o altă soluție echitabilă.
        </li>
      </ol>

      <h2 className="font-heading text-xl font-bold text-slate-900">6. Drepturile consumatorului</h2>
      <p>
        Te poți adresa <strong>ANPC</strong> (
        <a
          href="https://anpc.ro"
          target="_blank"
          rel="noopener noreferrer"
          className="text-cyan-600 underline"
        >
          anpc.ro
        </a>
        ) sau platformei europene <strong>SOL</strong> pentru soluționarea
        litigiilor online (
        <a
          href="https://ec.europa.eu/consumers/odr"
          target="_blank"
          rel="noopener noreferrer"
          className="text-cyan-600 underline"
        >
          ec.europa.eu/consumers/odr
        </a>
        ).
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900">7. Date producător</h2>
      <p>
        <strong>{COMPANY.legalName}</strong>
        <br />
        Sediu: {COMPANY.address}
        <br />
        CUI: {COMPANY.cui} · Reg. Comerț: {COMPANY.regCom}
        <br />
        Contact: {COMPANY.email} · {COMPANY.phone}
      </p>
    </LegalLayout>
  );
}
